// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"EventOverview_Wrapper__2vuet","Break":"EventOverview_Break__3IQTi","GameWrapper":"EventOverview_GameWrapper__2wbZs"};